(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nasaem-sticky-bar"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-nasaem-sticky-cart]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.open !== 'function') return;
    event.preventDefault();
    cart.open(trigger);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nasaem-ugc"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nasaem-ugc]').forEach(function (root) {
    if (root.dataset.ugcBound === '1') return;
    root.dataset.ugcBound = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-nasaem-ugc-item]'));
    var box = root.querySelector('[data-nasaem-ugc-lightbox]');
    var stage = root.querySelector('[data-ugc-stage]');
    if (!items.length || !box || !stage) return;
    document.body.appendChild(box);
    var index = 0;

    function render() {
      var item = items[index];
      if (!item) return;
      var kind = item.getAttribute('data-kind') || 'image';
      stage.innerHTML = '';
      if (kind === 'video' && item.getAttribute('data-video')) {
        var video = document.createElement('video');
        video.src = item.getAttribute('data-video');
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        stage.appendChild(video);
      } else if (kind === 'youtube' && item.getAttribute('data-video-id')) {
        var frame = document.createElement('iframe');
        frame.src = 'https://www.youtube.com/embed/' + item.getAttribute('data-video-id') + '?autoplay=1&rel=0';
        frame.allow = 'autoplay; encrypted-media; fullscreen';
        frame.allowFullscreen = true;
        stage.appendChild(frame);
      } else if (kind === 'vimeo' && item.getAttribute('data-video-id')) {
        var vimeo = document.createElement('iframe');
        vimeo.src = 'https://player.vimeo.com/video/' + item.getAttribute('data-video-id') + '?autoplay=1';
        vimeo.allow = 'autoplay; encrypted-media; fullscreen';
        vimeo.allowFullscreen = true;
        stage.appendChild(vimeo);
      } else {
        var img = document.createElement('img');
        img.src = item.getAttribute('data-src');
        img.alt = '';
        stage.appendChild(img);
      }
    }

    function openAt(i) {
      index = (i + items.length) % items.length;
      box.hidden = false;
      box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      render();
    }

    function close() {
      box.classList.remove('is-open');
      box.hidden = true;
      stage.innerHTML = '';
      document.body.style.overflow = '';
    }

    items.forEach(function (item, i) {
      item.addEventListener('click', function () {
        openAt(i);
      });
    });
    var prev = box.querySelector('[data-ugc-prev]');
    var next = box.querySelector('[data-ugc-next]');
    var closer = box.querySelector('[data-ugc-close]');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); openAt(index - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); openAt(index + 1); });
    if (closer) closer.addEventListener('click', close);
    box.addEventListener('click', function (e) {
      if (e.target === box) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') openAt(index - 1);
      if (e.key === 'ArrowRight') openAt(index + 1);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
